import { useMutation, useQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "../../config/constants";
import { toast } from "../../components/ui/Toast/useToast";
import { downloadDoc, getDocCategories, getDocuments } from "../../transactions/documents/documents";
import { size } from "lodash";

const {DOCUMENT_CATEGORIES, CATEGORY_DOCS, DOCUMENT} = QUERY_KEYS;

const genericError = ({message}) => {
  toast({
    variant: "destructive",
    description: message || "Παρουσιάστηκε κάποιο πρόβλημα",
  });
};

const getExtensionFromContentType = (contentType = "") => {
  const normalized = contentType.toLowerCase().split(";")[0].trim();

  if (normalized === "application/pdf") return "pdf";
  if (normalized === "image/png") return "png";
  if (normalized === "image/jpeg") return "jpg";
  if (normalized === "image/jpg") return "jpg";
  if (normalized === "image/tiff") return "tiff";
  if (normalized === "image/bmp") return "bmp";
  if (normalized === "image/gif") return "gif";

  return "file";
};

const getFilenameFromDisposition = (contentDisposition = "") => {
  const match = contentDisposition.match(/filename="?([^"]+)"?/i);
  return match?.[1] ?? null;
};

// Fetching

export const useGetDocCategories = () => {

  return useQuery({
    queryKey: [DOCUMENT_CATEGORIES],
    queryFn: async () => {
      return getDocCategories();
    },
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};

export const useGetDocuments = ({categoryId, plateno, enabled}) => {

  return useQuery({
    queryKey: [CATEGORY_DOCS, categoryId, plateno],
    queryFn: async () => {
      return getDocuments({categoryId, plateno});
    },
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: false,
    enabled: enabled,
  });
};

export const useViewDocument = () => {
  return useMutation({
    mutationFn: ({ uuid, categoryId, plateno }) =>
      downloadDoc({ uuid, categoryId, plateno }),

    onSuccess: (response, variables) => {
      const blobData = response?.data;
      const contentType =
        response?.headers?.["content-type"] || "application/octet-stream";

      const url = window.URL.createObjectURL(
        new Blob([blobData], { type: contentType })
      );

      window.open(url, "_blank", "noopener,noreferrer");
      window.URL.revokeObjectURL(url);
    },
  });
};

export const useDownloadDocument = () => {
  return useMutation({
    mutationFn: ({ uuid, categoryId, plateno }) =>
      downloadDoc({ uuid, categoryId, plateno }),

    onSuccess: (response, variables) => {
      const blobData = response?.data;
      const contentType =
        response?.headers?.["content-type"] || "application/octet-stream";

      const contentDisposition =
        response?.headers?.["content-disposition"] || "";

      const extension = getExtensionFromContentType(contentType);
      const backendFilename = getFilenameFromDisposition(contentDisposition);

      const filename =
        backendFilename ?? `${variables.categoryId}.${extension}`;

      const url = window.URL.createObjectURL(
        new Blob([blobData], { type: contentType })
      );

      // window.open(url, "_blank", "noopener,noreferrer");

      // To enable download the file uncomment bellow
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();

      link.remove();

      window.URL.revokeObjectURL(url);
    },
  });
};